import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotificationAlert from "react-notification-alert";

import { post_authin } from "stores/API/actions";
import SignInView from "./SignInView";
import { getMessage } from "config/util";

const App = () => {
  const dispatch = useDispatch();
  const ref = useRef();

  const toast = (error) => {
    const message = getMessage(error);
    dispatch_danger(message);
  };

  const dispatch_info = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-bell-55" />
            <span>{message}</span>
          </div>
        ),
        type: "info",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_danger = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-single-copy-04" />
            <span>{message}</span>
          </div>
        ),
        type: "danger",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_post_authin = (data, page) => {
    dispatch(
      post_authin({
        data,
        toast,
        page,
      })
    );
  };

  return (
    <>
      <div className="notification-container">
        <NotificationAlert ref={ref} />
      </div>

      <SignInView
        dispatch_info={dispatch_info}
        dispatch_danger={dispatch_danger}
        dispatch_post_authin={dispatch_post_authin}
      />
    </>
  );
};

export default App;
